import React from 'react'
import { Body, Box, CenteredBox, FreeSquizButton, H1 } from '../layout'
import { assetUrl } from '../../utilities'
import { Explosion, Eye, Lines, Target } from '../widgets'
import { Link } from 'gatsby'
import './TeamDevelopment.css'

export const TeamDevelopment = () => (
  <CenteredBox
    container
    column
    fullWidth
    className="team-development"
    gap={48}
  >
    <Box className="content-container" fullWidth>
      <Box className="main-text" column alignItems="left" gap={40}>
        <H1 className="title" weight={500} align="left" lineHeight="100px">Team<br/>Development<br/>In Real Time</H1>
        <Body align="left">
          Shivoo is a live team diagnostic and development platform that helps teams understand how they actually work - and improve it together, in the room.
        </Body>
      </Box>

      <img
        src={assetUrl(`analytics-compare-consensus.png`, 'website-showcase')}
        alt="game analytics"
        className="image"
        style={{ boxShadow: '5px 5px 0px 0px white' }}
      />
    </Box>

    <Box gap={16} className="next-steps-buttons">
      <Link to="/how-it-works" className="button-anchor">Learn more</Link>
      <FreeSquizButton />
    </Box>

    <Lines top={90} right={85} animate reverse />
    <Eye top={120} left={200} animate animationDelay="-5s" reverse />
    <Explosion top={620} right={340} animate />
    <Target top={620} left={520} animate animationDelay="-10s" />
  </CenteredBox>
)